import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-638636fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-row" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "avatar-wrapper" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-user" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "content")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-assistant" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "content")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "message"
}
const _hoisted_11 = {
  key: 1,
  class: "message"
}
const _hoisted_12 = { class: "assistant-message-wrapper" }
const _hoisted_13 = { class: "referenceWrapper" }
const _hoisted_14 = { class: "extra-button-wrapper" }

import { PropType, ref,computed } from 'vue'
import { ChatMessage } from '../../typings'
import TextLoading from '@/views/components/TextLoading.vue'
import ReferenceItem from '@/views/components/ReferenceItem.vue'
import CmdSuggestion from '@/views/components/CmdSuggestion.vue'
import { createNewFeedback } from '@/api/chat-session'
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageRow',
  props: {
  conversationGuid: { type: String ,deault: true ,required: true},
  message: { type: Object as PropType<ChatMessage>, required: true },
  senMessageEnable: { type: Boolean ,deault: true ,required: true},
  isLastMessage: { type: Boolean ,deault: true ,required: true},
  suggestionStatus: { type: Boolean ,deault: true ,required: true},
},
  emits: ["executeSg", "closeSg"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const token = computed(() => store.state.token);
//import MarkdownEditor from 'vue-markdown-editor'
//import { MdPreview } from 'md-editor-v3'
//import 'md-editor-v3/lib/preview.css'

// message：接受消息对象，展示消息内容和头像，并且根据角色调整消息位置。
const props = __props

const emit = __emit

const showSuggestion = ref(true);

const handleExcuteSuggestion = () =>{
  showSuggestion.value = false;
  emit('executeSg',props.message.command.name);
}

const handleCloseSuggestion = () =>{
  showSuggestion.value = false;
}

const convertNewlines=(text:String)=>{
      return text.replace(/\n/g, '\n');
    }

const bCopied = ref(false);
const bClickedLike = ref(false);
const bclickedDislike = ref(false);
// 获取 tooltip 的 ref
const copyTooltipRef = ref<any>(null);
const copyTooltipVisible = ref(false);
//复制
const copyMessage = () =>{
  navigator.clipboard.writeText(props.message.content).then(() => {
    bCopied.value = true;
    copyTooltipVisible.value = false; 
    setTimeout(() => {
      bCopied.value = false;
    }, 2000);
  }).catch(err => {
    console.error('Failed to copy text to clipboard:', err);
  });
  
  }  
//点赞
const likeResponse = async () =>{
    if(!bClickedLike.value && !bclickedDislike.value)
    {
      createNewFeedback(props.conversationGuid, props.message.guid, 1, token.value).then(
        (res)=>
        {
          if(undefined == res)
          {
            return;
          }
          
          bClickedLike.value = true;
        }
      )

    }
}    
//点踩
const dislikeResponse = () =>{
  if(!bClickedLike.value && !bclickedDislike.value)
    {
      createNewFeedback(props.conversationGuid, props.message.guid, 2, token.value).then(
        (res)=>
        {
          if(undefined == res)
          {
            return;
          }
          
        bclickedDislike.value = true;
        }
      )
    }
  }   

return (_ctx: any,_cache: any) => {
  const _component_v_md_preview = _resolveComponent("v-md-preview")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.message.content || !__props.message.content && !__props.senMessageEnable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (__props.message.role === 'user')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          ]),
          (__props.message.role === 'user')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_v_md_preview, {
                  class: "md-preview",
                  text: __props.message.content
                }, null, 8, ["text"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (__props.message.content)
                    ? (_openBlock(), _createBlock(_component_v_md_preview, {
                        key: 0,
                        class: "md-preview",
                        text: convertNewlines(__props.message.content)
                      }, null, 8, ["text"]))
                    : (__props.isLastMessage && !__props.message.content)
                      ? (_openBlock(), _createBlock(TextLoading, { key: 1 }))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.references, (reference, index) => {
                      return (_openBlock(), _createBlock(ReferenceItem, {
                        index: index,
                        reference: reference
                      }, null, 8, ["index", "reference"]))
                    }), 256))
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tooltip, {
                            modelValue: copyTooltipVisible.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((copyTooltipVisible).value = $event)),
                            content: _ctx.$t('messageRow.copy'),
                            placement: "bottom",
                            "open-delay": 500,
                            "hide-after": 0
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "extra-button",
                                icon: "el-icon-copy",
                                onClick: copyMessage
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(bCopied.value?  'el-icon-copied':'el-icon-copy')
                                  }, null, 2)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "content"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tooltip, {
                            content: _ctx.$t('messageRow.good'),
                            placement: "bottom",
                            "open-delay": 500,
                            "hide-after": 0
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "extra-button",
                                onClick: likeResponse
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(bClickedLike.value ? 'el-icon-good-fill' : 'el-icon-good')
                                  }, null, 2)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tooltip, {
                            content: _ctx.$t('messageRow.bad'),
                            placement: "bottom",
                            "open-delay": 500,
                            "hide-after": 0
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "extra-button",
                                onClick: dislikeResponse
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(bclickedDislike.value ? 'el-icon-bad-fill' : 'el-icon-bad')
                                  }, null, 2)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})